var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"input-info"},[_c('v-icon',{attrs:{"color":"info_gray","small":""}},[_vm._v(" mdi-information-outline ")]),_vm._v(" "+_vm._s(_vm.msg)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }